import { ChurnReasonsGuard } from '@core/churn-flow-logic';
import {
  ChurnFarewellPageComponent,
  ChurnFlowSubscriptionLossPageComponent,
  ChurnIntroPageComponent,
  ChurnMissingFeaturesPageComponent,
  ChurnMovingToAnotherToolPageComponent,
  ChurnNotHiringPageComponent,
  ChurnOrganizationalChangesPageComponent,
  ChurnOtherReasonPageComponent,
  ChurnReasonsPageComponent,
  ChurnTooComplicatedPageComponent,
  ChurnTooExpensivePageComponent,
  ChurnUnhelpfulSupportPageComponent,
} from '@core/churn-flow-smart-ui';
import { ChurnReason } from '@core/churn-flow-types';

export const ChurnFlowRoutes = [
  {
    path: 'intro',
    component: ChurnIntroPageComponent,
  },
  {
    path: 'reasons',
    component: ChurnReasonsPageComponent,
    canActivate: [ChurnReasonsGuard],
  },
  {
    path: ChurnReason.TooComplicated,
    component: ChurnTooComplicatedPageComponent,
  },
  {
    path: ChurnReason.MissingFeatures,
    component: ChurnMissingFeaturesPageComponent,
  },
  {
    path: ChurnReason.MovingToAnotherTool,
    component: ChurnMovingToAnotherToolPageComponent,
  },
  {
    path: ChurnReason.OrganizationalChanges,
    component: ChurnOrganizationalChangesPageComponent,
  },
  {
    path: ChurnReason.NotHiring,
    component: ChurnNotHiringPageComponent,
  },
  {
    path: ChurnReason.TooExpensive,
    component: ChurnTooExpensivePageComponent,
  },
  {
    path: ChurnReason.UnhelpfulSupport,
    component: ChurnUnhelpfulSupportPageComponent,
  },
  {
    path: ChurnReason.Other,
    component: ChurnOtherReasonPageComponent,
  },
  {
    path: 'subscription-loss',
    component: ChurnFlowSubscriptionLossPageComponent,
  },
  {
    path: 'farewell',
    component: ChurnFarewellPageComponent,
  },
  {
    path: '**',
    redirectTo: 'intro',
  },
];
